import React, { useEffect, useState } from 'react'
import './OnboardingFlow.scss'
import OnboardingHeader from '../../../components/Header/AcceleratorHeader/OnboardingHeader'
import Loader from '../../../components/Loader/Loader'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { Steps, Progress, Button as AntButton } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import StartupStepFinishIcon from '../../../assets/images/Icons/StartupStepFinishIcon'
import StepOnePage from './StepOnePage'
import StepTwoPage from './StepTwoPage'
import StepThreePage from './StepThreePage'
import StepFourPage from './StepFourPage'
import StepFivePage from './StepFivePage'
import StartupStepDoneIcon from '../../../assets/images/Icons/StartupStepDoneIcon'
import DoneStepPage from './DoneStepPage'

const OnboardingFlow = () => {
  const { Step } = Steps
  const [loading, setLoading] = useState(false)
  const [current, setCurrent] = useState(0)
  const [count, setCount] = useState(0)

  useEffect(() => {
    document.querySelector('body').scrollTo(0, 0)
    window.history.pushState({}, '', `/accelerator/onboarding/step-${current + 1}`)
  }, [current])
  /**
   * Function to move to the previous step in the onboarding process.
   */
  const prev = () => {
    setCount(count - 1)
    setCurrent(current - 1)
    // dispatch(fetchStartupUserInfoUpdate({ onboarding_step: current - 1 }))
  }

  //Function to move to the next step in the onboarding process.
  const next = () => {
    setCount(count + 1)
    setCurrent(current + 1)
  }

  const steps = [
    {
      title: 'Step - 1',
      icon: <span className="StepIcon">1</span>,
      content: <StepOnePage next={next} />,
    },
    {
      title: 'Step - 2',
      icon: <span className="StepIcon">2</span>,
      content: <StepTwoPage next={next} />,
    },
    {
      title: 'Step - 3',
      icon: <span className="StepIcon">3</span>,
      content: <StepThreePage next={next} />,
    },
    {
      title: 'Step - 4',
      icon: <span className="StepIcon">4</span>,
      content: <StepFourPage next={next} />,
    },
    {
      title: 'Step - 5',
      icon: <span className="StepIcon">5</span>,
      content: <StepFivePage next={next} />,
    },
    {
      title: 'Done',
      icon: <StartupStepDoneIcon />,
      content: <DoneStepPage />,
    },
  ]
  return (
    <>
      <OnboardingHeader
      // onSaveAndLogout={() => dispatch(SaveAndExitClicked())}
      // showSaveAndLogout={!startInfoFlag}
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <span>
            <Container className="mb-3 mt-5">
              <Row>
                <Col lg={5} md={7} xs={current == 0 ? 8 : 12} className="mx-auto">
                  <Steps className="accelerator-steps" current={current >= 1 ? 1 : 0}>
                    {steps.map(
                      (item, i) =>
                        i < current + 2 &&
                        i > current - 2 && (
                          <Step
                            className={i === 0 ? 'firstStep' : i === 6 ? 'doneStep' : ''}
                            icon={i < current ? <StartupStepFinishIcon /> : item.icon}
                            key={i}
                            title={item.title}
                          />
                        ),
                    )}
                  </Steps>
                </Col>
              </Row>
            </Container>
            <Container className="mb-3">
              <Row>
                <Col md={8} className="mx-auto mb-3">
                  <Progress percent={Math.round(((count + 1) / 6) * 100)} />
                </Col>
              </Row>
            </Container>
          </span>

          {/*** Progress Bar is here ***/}
          {steps[current].content}

          {/* New Back & Continue buttons */}
          <section className="bottomButton mb-3">
            <Container className="">
              <Row>
                <Col md={4} xs={12} className="text-center mx-auto">
                  {current > 0 && (
                    <button
                      className="backBtnOnboarding"
                      onClick={() => {
                        prev()
                      }}
                    >
                      <ArrowLeftOutlined />
                      &nbsp; Back
                    </button>
                  )}
                </Col>
              </Row>
            </Container>
          </section>
        </>
      )}
    </>
  )
}

export default OnboardingFlow
